module.exports = {"controls":{"canvas":{"contract":"Contract one level","expand":"Expand one level","fitToScreen":"Fit the search strategy to the canvas","snapToGrid":"Toggle Snap to Grid"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-uk/controls.json
// module id = SCHl
// module chunks = 1